<div class="single-checkbox" [class.disabled]="disabled">
  <label
    [ngClass]="type"
    [class.checked]="checked"
    [class.checkish]="
      value &&
      toCheck &&
      toCheck.length !== 0 &&
      toCheck.length !== value.length
    "
    (mouseup)="change($event)"
    [class.no-text]="label === ''"
  >
    <span class="tick"></span>
    <span [outerHTML]="label" *ngIf="label !== ''"></span>
  </label>
</div>
